export default "__VITE_ASSET__D7j34AU3__"